import { render, staticRenderFns } from "./GeneralInformationListItem.vue?vue&type=template&id=85c7e828&"
import script from "./GeneralInformationListItem.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformationListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports